import React, { useState, useEffect, useReducer } from 'react'
import { Col, Panel, Row, IconButton, Icon, CheckPicker, Input } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import {
  exportEfillingSummaryReport,
  searchEfillingSummaryReport,
} from '../../redux/actions/eFilling'
import { downloadFile } from '../../utils/fileUtil'
import { getValueFromOptions } from '../../utils/dataUtil'
import SummaryReporteFillingTable from './SummaryReporteFillingTable'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function SummaryReporteFillingWidget(props) {
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)
  const projectCode = sessionStorage.getItem('projectCode')
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  // const [searchData, setSearchData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [withholdingTypeValue, setWithholdingTypeValue] = useState([])
  const [projectCodeValue, setProjectCodeValue] = useState()
  const [withholdingYearValue, setWithholdingYearValue] = useState([])
  const [taxpayerIdValue, setTaxpayerIdValue] = useState()

  useEffect(() => {
    // setVoucherSchema(mockSchema.model || [])
  }, [])

  const handleSearchEFilling = async () => {
    setIsLoading(true)
    startLoading()

    const request = {
      withholdingType: withholdingTypeValue?.map((item) => {
        let label = getValueFromOptions(formSchema.forms.withholdingType?.options, item)
        return label
      }),
      projectCode: projectCode || projectCodeValue,
      withholdingYear: withholdingYearValue || [],
      taxpayerId: taxpayerIdValue,
      //getValueFromOptions(formSchema.forms.withholdingType?.options, withholdingTypeValue) || '',
    }

    // setSearchData(request)
    // console.log('request', request)

    try {
      const response = await searchEfillingSummaryReport(request)
      // console.log('handleSearchEFilling==>', response)
      setFormSchema(response.model)
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleExportFile = async () => {
    setIsLoading(true)
    startLoading()

    const request = {
      withholdingType: withholdingTypeValue?.map((item) => {
        let label = getValueFromOptions(formSchema.forms.withholdingType?.options, item)
        return label
      }),
      projectCode: projectCode || projectCodeValue,
      withholdingYear: withholdingYearValue || [],
      taxpayerId: taxpayerIdValue,
    }
    // setSearchData(request)
    // console.log('request', request)

    try {
      const file = await exportEfillingSummaryReport(request)

      if (file) {
        downloadFile(file, `สรุปภาษี (รายปี).xlsx`)
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })
      }
    } catch (e) {
      //let errorJson = JSON.parse(await e.response.data.text())
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        // collapsible
        defaultExpanded
        bordered
        //header={'รายงานการยื่นแบบและชำระภาษีออนไลน์ (e-Filing)'}
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        {isLoading && <OverlayLoader />}

        <Row style={{ marginTop: 30, marginBottom: 10 }}>
          <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
            {formSchema.forms.withholdingType.label}
          </Col>
          <Col lg={8} md={8} sm={8} xs={8}>
            <CheckPicker
              data={formSchema.forms.withholdingType?.options || []}
              defaultValue={formSchema.forms.withholdingType.defaultValue}
              value={withholdingTypeValue}
              block
              placeholder="เลือก"
              searchable={false}
              onChange={(value) => {
                // console.log('x => ', value)
                setWithholdingTypeValue(value)
              }}
            />
          </Col>

          <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
            {formSchema.forms.withholdingYear.label}
          </Col>
          <Col lg={8} md={8} sm={8} xs={8}>
            <CheckPicker
              data={formSchema.forms.withholdingYear?.options || []}
              defaultValue={formSchema.forms.withholdingYear.defaultValue}
              value={withholdingYearValue}
              block
              placeholder="เลือก"
              searchable={false}
              onChange={(value) => {
                // console.log('x => ', value)
                setWithholdingYearValue(value)
              }}
            />
          </Col>
        </Row>

        <Row>
          {!formSchema?.forms?.isRoleUsers && (
            <>
              <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                {formSchema.forms.projectCode.label}
              </Col>
              <Col lg={8} md={8} sm={8} xs={8}>
                <Input
                  placeholder={formSchema.forms.projectCode.label}
                  defaultValue={formSchema.forms.projectCode.value}
                  onChange={(value) => {
                    setProjectCodeValue(value)
                  }}
                />
              </Col>
            </>
          )}

          {formSchema.forms.taxpayerId && (
            <>
              <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                {formSchema.forms.taxpayerId.label}
              </Col>
              <Col lg={8} md={8} sm={8} xs={8}>
                <Input
                  placeholder={formSchema.forms.taxpayerId.label}
                  defaultValue={formSchema.forms.taxpayerId.value}
                  onChange={(value) => {
                    setTaxpayerIdValue(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row style={{ marginBottom: 20, marginTop: 20 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="search" className="bt-gost-icon-radius" />}
              onClick={handleSearchEFilling}
              style={{ marginRight: 20 }}
            >
              ค้นหา
            </IconButton>

            <IconButton
              appearance="ghost"
              icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
              onClick={handleExportFile}
            >
              Export to Excel
            </IconButton>
          </Col>
        </Row>

        <SummaryReporteFillingTable data={formSchema?.eFillingSummaryReportListValues} />
      </Panel>
    </>
  )
}
